import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-required-info',
    templateUrl: './required-info.component.html',
    styleUrl: './required-info.component.scss',
    imports: [NgClass],
})
export class RequiredInfoComponent {
    @Input()
    public smallMargins = false;
}
